import React, { useState } from 'react'


export default function SinglePlayerGame() {
    
    let [currTurn, setCurrTurn] = useState('X')
    let [board, setBoard] = useState([[' ', ' ', ' '], [' ', ' ', ' '], [' ', ' ', ' ']])
    let [xScore, setXscore] = useState(0)
    let [oScore, setOscore] = useState(0)
    let [gameStatus, setGameStatus] = useState('Game has not started yet!')

    let updateBoard = (row, col) => {
        let boardCopy = JSON.parse(JSON.stringify(board))
        if (boardCopy[row][col] === ' ') {
            boardCopy[row][col] = currTurn
            currTurn === 'X' ? setCurrTurn('O') : setCurrTurn('X')
            setBoard(boardCopy)
            if (whoWon(boardCopy, currTurn)) {
                setGameStatus(`${currTurn} won the match`)
                currTurn === 'X' ? setXscore(prev => prev + 1) : setOscore(prev => prev + 1)
                setBoard([[' ', ' ', ' '], [' ', ' ', ' '], [' ', ' ', ' ']])
                setCurrTurn('X')
            }
            else {
                let bol = true
                boardCopy.forEach(el => {
                    el.forEach(item => { if (item === " ") bol = false })
                })
                if (bol === true) {
                    setGameStatus('Match Draw')
                    setBoard([[' ', ' ', ' '], [' ', ' ', ' '], [' ', ' ', ' ']])
                    setCurrTurn('X')
                }
                else setGameStatus('Match on progress')
            }
        }
    }

    let whoWon = (board, z) => {
        return (board[0][2] === z && board[1][2] === z && board[2][2] === z) ||
            (board[0][1] === z && board[1][1] === z && board[2][1] === z) ||
            (board[0][0] === z && board[1][0] === z && board[2][0] === z) ||
            (board[0][0] === z && board[0][1] === z && board[0][2] === z) ||
            (board[1][0] === z && board[1][1] === z && board[1][2] === z) ||
            (board[2][0] === z && board[2][1] === z && board[2][2] === z) ||
            (board[0][0] === z && board[1][1] === z && board[2][2] === z) ||
            (board[0][2] === z && board[1][1] === z && board[2][0] === z)
            ? true : false;
    }


    return (
        <div className="Game">

            <div className="score-card">
                <div className="score">
                    <p className="text">X</p>
                    <p className="text1">{xScore}</p>
                </div>
                <div className="score">
                    <p className="text">O</p>
                    <p className="text1">{oScore}</p>
                </div>
            </div>
            <div className="game-status">
                <div className="header">
                    <h1>{gameStatus}</h1>
                    <h3 style={{ opacity: 0.7 }}>Next Turn: {currTurn}</h3>
                </div>

                <div className="board">
                    {board.map((el, row) => { return (el.map((item, col) => <button onClick={() => updateBoard(row, col)} className="board-room">{item}</button>)) })}
                </div>
            </div>
        </div>
    )
}
